export default __webpack_public_path__ + "static/media/olympaid.09ae517c.svg";